export enum ETemplateStatus {
  PUBLISHED = 'published',
  DATA_COLLECTION = 'data_collection',
  DRAFT = 'draft',
  TO_WORK_IN_PROCESS = 'to_work_in_process',
  UNPUBLISHED = 'unpublished',
  WORK_IN_PROGRESS = 'work_in_progress',
  IN_PROCESS = 'in_process'
}

export enum ETemplateKind {
  DOCUMENT = 'document',
  TICKET = 'ticket',
  FORM = 'form',
  PROFILE = 'profile',
  SIGNATURE_QUOTE = 'signature_quote',
  TEMPLATE = 'template'
}

export enum ETemplateFlow {
  TEMPLATE_DRAFT = 'template_draft',
  TEMPLATE_PUBLISHED = 'template_published',
  TEMPLATE_UNPUBLISHED = 'template_unpublished',
  TEMPLATE_ALL = 'template_all'
}

export enum ETemplateProcessKind {
  DOCUMENT = 0,
  TICKET = 1,
  FORM = 2,
  SIGNATURE_QUOTE = 3,
  PROFILE = 4
}

export enum ETemplateUpdatePaths {
  NAME = '/name',
  DEPARTMENT_IDS = '/departmentIds'
}

/**
 * Lifecycle action sent to `PUT /clients/{clientId}/templates/{templateId}/process` (API v3).
 */
export enum ETemplateProcessAction {
  TO_WORK_IN_PROCESS = 'to_work_in_process',
  TO_PUBLISHING = 'to_publishing',
  TO_PUBLISHED = 'to_published',
  TO_UNPUBLISHED = 'to_unpublished',
  TO_DRAFT = 'to_draft'
}

/**
 * Screen that dispatched a template lifecycle action; effects use it to decide whether to
 * navigate (editor) or to reload the list (list).
 */
export enum ETemplateActionSource {
  EDITOR = 'editor',
  LIST = 'list'
}

/**
 * Maps the numeric template kind of API v3 to the kind name used by the editor and the info tab.
 * Any value outside the known kinds maps to `ETemplateKind.PROFILE`, as the previous inline mapping did.
 * @param kind numeric kind returned by API v3
 * @returns the kind name
 */
export function templateKindToName(kind: ETemplateProcessKind): ETemplateKind {
  switch (kind) {
    case ETemplateProcessKind.DOCUMENT:
      return ETemplateKind.DOCUMENT;
    case ETemplateProcessKind.TICKET:
      return ETemplateKind.TICKET;
    case ETemplateProcessKind.FORM:
      return ETemplateKind.FORM;
    case ETemplateProcessKind.SIGNATURE_QUOTE:
      return ETemplateKind.SIGNATURE_QUOTE;
    default:
      return ETemplateKind.PROFILE;
  }
}